import { useEffect } from "react";
import { useI18n } from "../i18n";
import { saveKioskDevice, setKioskMode, type KioskDeviceInfo } from "../kioskDevice";

/**
 * (Task DD2, owner decision) A tablet paired as a kiosk DEVICE before staff clocking moved to their own phones: it can't
 * clock anyone any more (the API answers clock_own_device). Explain it and offer the normal sign-in, which forgets the
 * device credential on this tablet.
 */
export function RetiredKioskScreen({ device }: { device: KioskDeviceInfo }) {
  const { t } = useI18n();
  useEffect(() => { setKioskMode(false); }, []);
  return (
    <div className="shell kiosk-shell" data-testid="kiosk-retired">
      <div className="page narrow stack" style={{ margin: "auto", padding: 24, gap: 16, textAlign: "center" }}>
        <div aria-hidden style={{ fontSize: 48 }}>📱</div>
        <h1 className="page-title">{t("dd2.kiosk.retiredTitle")}</h1>
        <p className="muted">{device.tenantName}{device.branchName ? " · " + device.branchName : ""}</p>
        <p>{t("dd2.kiosk.retired")}</p>
        <button className="btn btn-primary btn-lg btn-block" data-testid="kiosk-retired-signin" onClick={() => { saveKioskDevice(null); window.location.assign("/login"); }}>{t("dd2.kiosk.signIn")}</button>
      </div>
    </div>
  );
}
